export default "__VITE_ASSET__CiUnfiob__"